import { AccountDocument } from '@og-shared/types';

export function getAccountName(account: AccountDocument | undefined) {
  if (!account) return '';
  return account.name_custom || account.name;
}
